module.exports = __webpack_public_path__ + "img/icon-metro-3.c518df94.png";